<template>
    <div class="employees-chart-area">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-8">
                    <AudienceOverview />

                    <div class="row">
                        <div class="col-xxl-6">
                            <TotalEmployees />
                        </div>

                        <div class="col-xxl-6">
                            <EmployeesAvailability />
                        </div>
                    </div>

                    <div class="total-hiring-sources-wrap">
                        <div class="row">
                            <div class="col-xxl-8">
                                <EmployeesAvailabilityChart />
                            </div>

                            <div class="col-xxl-4">
                                <SendInvitation />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <UpcomingInterviews />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AudienceOverview from './AudienceOverview'
import TotalEmployees from './TotalEmployees'
import EmployeesAvailability from './EmployeesAvailability'
import EmployeesAvailabilityChart from './EmployeesAvailabilityChart'
import SendInvitation from './SendInvitation'
import UpcomingInterviews from './UpcomingInterviews'

export default {
    name: 'LmsAcademyContent',
	components: {
        AudienceOverview,
		TotalEmployees,
        EmployeesAvailability,
        EmployeesAvailabilityChart,
        SendInvitation,
        UpcomingInterviews,
	},
}
</script>

<style lang="scss">
/* Min width 1400px to Max width 1700px */
@media only screen and (min-width: 1400px) and (max-width: 1700px) {
    .employees-chart-area {
        .col-xxl-6 {
            flex: 0 0 auto;
            width: 100%;
        }
    }
}
</style>